export default angular
  .module("CodeSystemCodesCtrl", [
    "angularUtils.directives.dirPagination",
    "ui.bootstrap",
  ])
  .controller("CodeSystemCodesController", [
    "$scope",
    "$stateParams",
    "modal",
    "System",
    function (
      $scope,
      $stateParams,
      modal,
      System,
    ) {
      $scope.searchString = "";
      $scope.sortCodes = {
        column: "CODE_SYSTEM",
        direction: false,
      };
      $scope.loadingCodes = false;
      $scope.organizations = [];

      const codeSystemId = $stateParams.id;

      const loadCodeSystemCodes = function (id) {
        if (id) {
          $scope.loadingCodes = true;
          System.loadCodeSystemCodes(id, (codeSystemCodes) => {
            $scope.codeSystem.CODES = codeSystemCodes;
            $scope.loadingCodes = false;
          });
        }
      };

      $scope.loadOrganizationTags = function (query, code) {
        return $scope.organizations.filter(organization => (
          !code.organizations.some(({ NAME }) => NAME === organization.NAME) &&
          organization.NAME.toLowerCase().indexOf(query.toLowerCase()) !== -1
        ));
      };

      $scope.changeSorting = function (column) {
        if ($scope.sortCodes.column === column) {
          $scope.sortCodes.direction = !$scope.sortCodes.direction;
        } else {
          $scope.sortCodes.column = column;
          $scope.sortCodes.direction = false;
        }
      };

      $scope.saveCodeSystemCode = (code) => {
        System.saveCode(code, () => {
          loadCodeSystemCodes(codeSystemId);
        });
      };

      $scope.removeCodeSystemCode = (code) => {
        modal.openDelete(code.ID, "Code").result.then(() => {
          System.deleteCode(code, () => {
            loadCodeSystemCodes(codeSystemId);
          });
        });
      };

      $scope.addNewCodeSystemCode = (searchString) => {
        const newCode = {
          CODE: searchString.$,
          CODE_SYSTEM_ID: $scope.codeSystem.ID,
        };
        System.addNewCodeAliasCode(newCode, () => {
          loadCodeSystemCodes(codeSystemId);
        });
      };

      loadCodeSystemCodes(codeSystemId);
      System.loadOrganizationTags((organizations) => {
        $scope.organizations = organizations;
      });
    },
  ]);
